import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/clientsConfig";

const UnassignedLead = () => {
  const userObj = JSON.parse(localStorage.getItem("userData"));

  const navigate = useNavigate();
  const handleLeadUpload = () => {
    navigate("/bod/lead-upload");
  };
  const handleLeadSplit = () => {
    navigate("/bod/lead/reassign", {
      state: {
        unassignedObj,
        leadCount: unassignedObj.totalCount,
        assignStatus: true,
  }});
  };
  const [unassignedObj, setUnassignedObj] = useState({});

  useEffect(() => {
    (async () => {
      console.log(userObj);
      try {
        const response = await axios.get(
          `${baseUrl}/leads/` +
            userObj.teamId[0].id +
            "/Fresh"
        );
        const data = response.data;
        setUnassignedObj(data);
        console.log(data);
        // setLeadSources(data);
      } catch (error) {
        console.error("Error fetching leads:", error);
        // Handle error if needed
      }
    })();
  }, []);

  return (
    <div className="rounded-lg shadow-md  bg-white xl:w-[480px] 2xl:w-[520px] 3xl:w-[670px] custom-xl:w-[520px] 4xl:w-[900px]  ">
      <div className="flex justify-between 4xl:h-24 bg-customGreen rounded-t-lg h-16 cursor-default">
        <span className="text-2xl font-semibold text-white mt-4 ml-8 xl:text-lg   custom-xl:text-xl 2xl:text-xl lg:text-lg 3xl:text-2xl 4xl:text-3xl whitespace-nowrap  4xl:mt-8 ">
          Unassigned Fresh Leads
        </span>
        <button
          onClick={handleLeadUpload}
          className="bg-white ml-12 w-32 xl:text-xs xl:w-28 lg:w-24 4 4xl:w-48 4xl:text-2xl whitespace-nowrap px-1  custom-xl:w-32 custom-xl:text-sm lg:text-xs h-8 4xl:mt-8  rounded-md mt-4 mr-6 "
        >
          Add New Leads
        </button>
      </div>
      <div
        onClick={() => handleLeadSplit(unassignedObj)}
        className="flex justify-between cursor-pointer h-36   3xl:items-center"
      >
        <table className="border-collapse border-slate-400 w-full">
          <tr className="">
            <td className="border border-slate-300">
              {" "}
              <div className="text-center">
                <h2 className=" font-bold text-2xl">
                  {unassignedObj.oneDayOld}
                </h2>
                <p className="text-base ">1 day old</p>
              </div>
            </td>
            <td className="border border-slate-300">
              <div className="  text-center ">
                <h2 className="font-bold text-2xl">
                  {unassignedObj.twoDaysOld}
                </h2>
                <p className=" text-base">2 day old</p>
              </div>
            </td>
            <td className="border border-slate-300">
              <div className="text-center">
                <h2 className="font-bold text-2xl">
                  {unassignedObj.criticallyOld}
                </h2>
                <p className="text-red-500 text-base ">Critically old</p>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div className="flex items-center justify-center font-medium text-xl w-full h-10">
        <p>Total available leads: </p>{" "}
        <p className="font-bold"> {unassignedObj.totalCount}</p>
      </div>
    </div>
  );
};

export default UnassignedLead;
